import { Button } from "@material-ui/core";

export default function ButtonContinue({ textButtom, disabled, onClick }) {
  return (
    <Button
      fullWidth
      variant="contained"
      style={{
        marginTop: 12,
        borderRadius: 24,
        padding: "12px 0",
        fontSize: "1rem",
        marginBottom: "8px",
        color: "white",
        fontWeight: "bold",
        backgroundColor: disabled ? "#64b5f6" : "#003876",
      }}
      disabled={disabled}
      onClick={() => onClick()}
    >
      {textButtom}
    </Button>
  )
}
